import retrievePermission from './retrieve-permission';
import createPagination from './create-pagination';

export default {
	retrievePermission,
	createPagination
};
